/**
 * Pariaa Custom Sections - shared behaviours
 * Handles: Owl Carousel init/reinit, tab switching, click-to-play video
 * items, and scroll-reveal animation. Works on first load and on
 * `shopify:section:load` (theme editor).
 */
(function () {
  function initCarousel(el) {
    if (!el || el.dataset.owlInitialized === 'true') return;
    var opts = {
      items: parseInt(el.dataset.itemsDesktop || '4', 10),
      margin: parseInt(el.dataset.gap || '24', 10),
      loop: el.dataset.loop === 'true',
      autoplay: el.dataset.autoplay === 'true',
      autoplayTimeout: parseInt(el.dataset.speed || '4000', 10),
      autoplayHoverPause: true,
      nav: el.dataset.arrows === 'true',
      dots: el.dataset.dots === 'true',
      navText: [
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>',
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>'
      ],
      responsive: {
        0: { items: parseInt(el.dataset.itemsMobile || '1', 10) },
        750: { items: parseInt(el.dataset.itemsTablet || '2', 10) },
        990: { items: parseInt(el.dataset.itemsDesktop || '4', 10) }
      }
    };

    window.PariaaVendors.owlCarousel().then(function ($) {
      $(el).owlCarousel(opts);
      el.dataset.owlInitialized = 'true';
    });
  }

  function initAllCarousels(root) {
    (root || document).querySelectorAll('.pariaa-carousel[data-owl]').forEach(initCarousel);
  }

  function initTabs(root) {
    (root || document).querySelectorAll('[data-pariaa-tabs]').forEach(function (wrapper) {
      var tabs = wrapper.querySelectorAll('[data-tab-target]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-tab-target');
          wrapper.querySelectorAll('[data-tab-target]').forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
          });
          wrapper.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
            var active = panel.getAttribute('data-tab-panel') === target;
            panel.classList.toggle('is-active', active);
            if (active) {
              var carousel = panel.querySelector('.pariaa-carousel[data-owl]');
              if (carousel) initCarousel(carousel);
            }
          });
        });
      });
    });
  }

  function initVideoItems(root) {
    (root || document).querySelectorAll('.pariaa-video-item').forEach(function (item) {
      var video = item.querySelector('video');
      if (!video) return;
      item.addEventListener('click', function () {
        var playing = item.classList.contains('is-playing');
        root.querySelectorAll('.pariaa-video-item.is-playing').forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-playing');
            var v = other.querySelector('video');
            if (v) v.pause();
          }
        });
        item.classList.toggle('is-playing', !playing);
        if (!playing) {
          video.currentTime = 0;
          video.play();
        } else {
          video.pause();
        }
      });
      video.addEventListener('ended', function () {
        item.classList.remove('is-playing');
      });
    });
  }

  function initReveal(root) {
    var items = (root || document).querySelectorAll('.pariaa-animate');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    items.forEach(function (el) { observer.observe(el); });
  }

  function initSection(root) {
    initAllCarousels(root);
    initTabs(root);
    initVideoItems(root);
    initReveal(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSection(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initAllCarousels(document);
  });

  window.PariaaSections = { init: initSection };
})();
